import { render, staticRenderFns } from "./scoreEditDialog.vue?vue&type=template&id=2d9a0016&scoped=true"
import script from "./scoreEditDialog.vue?vue&type=script&lang=js"
export * from "./scoreEditDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreEditDialog.vue?vue&type=style&index=0&id=2d9a0016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a0016",
  null
  
)

export default component.exports